/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface AttributeListArgs {
  attributes: Record<string, string>[];
  ignoreIdentifiers?: boolean;
  isObject?: boolean;
  listItemClassNames?: string;
}

export default class AttributeList extends Component<AttributeListArgs> {}
